<template>
  <div id="community">
    <div class="col-lg-6 offset-lg-3" id="logo"><img src="/static/image/logo.png">
    <div class="trad"  style="float: right; color: white"><a href="#"> <span @click="changeLang()">Ita/Eng</span></a></div>
    </div>
    <div id="header-community">
      <div style="color: #ffffff; margin-top: 50px" class="col-lg-6 offset-lg-3">
        <h3>{{$t("titolo")}}</h3>
        <h4>{{$t("sottotitolo")}}</h4>
      </div>

    </div>
    <div  class="col-lg-4 offset-lg-4" id="formHubspot">

    </div>
  </div>
</template>

<script>
  //import HeaderPage from "./HeaderPage";
  export default {
    name: "Community",
    mounted: function (){
      if (window.hbspt){
        window.hbspt.forms.create({
          portalId: "5864348",
          formId: "638f440b-498b-41d7-81bb-ff9b6ce6e675",
          target: "#formHubspot"
        });
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          titolo: 'Ciao! Vuoi ricevere in anteprima aggiornamenti su eventi e iniziative in Tenuta?',
          sottotitolo: 'Iscriviti subito!'
        },
        en: {
          titolo: 'Hi There! Want to keep in touch?',
          sottotitolo: 'Leave your data here!'
        }
      }
    },
    methods: {
      changeLang: function () {
        this.$root.$i18n.locale = this.$root.$i18n.locale === 'it' ? 'en' : 'it'
        this.$route.params.language = this.$root.$i18n.locale === 'it' ? 'ita' : 'eng'
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  body{
    background-color: #212529 !important;
  }

  #community {
    #logo{
      margin-top: 50px;
      display: block;
      text-align: center;
    }
    #hsForm_638f440b-498b-41d7-81bb-ff9b6ce6e675 {
        margin-left: auto;
        margin-right: auto;
    }
    #header-community{
      text-align: center;
      font-family: 'Lato-Light';

      h4{
        font-family: 'Lato-Light';
      }
    }
    @media only screen and (max-width: 768px) {
      #logo {
        img {
          display: block;
          text-align: center;
          margin-left: auto;
          margin-right: auto;
          max-width: 180px;
        }
        .trad{
          margin-top: -30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Community.vue